import React, { Component } from 'react';
import "./View.scss"
import "./Animation.scss"
import { Redirect } from "react-router-dom"
import ScrollableAnchor from 'react-scrollable-anchor'
import Button from '../../Helpers/Button/Button';
import { setScrollNaming } from '../../Services/ScrollURL';

class View extends Component {
  constructor() {
    super();
    this.state = {
      isActive: false
    }
  }
  handlePaging() {
    // return window.location.href = "./#/Article/2";
    return "/Article/2";
  }
  componentDidMount() {
    setScrollNaming(this.section);
  }
  componentWillReceiveProps(nextProps) {
    window.setTimeout(() =>
      this.setState({
        isActive: nextProps.currentScreen == 4
      }), 500);
  }
  render() {
    return (
      <section className="section section-view" ref={section => this.section = section}>
        <div className="padding">
          <div className="container">
            <div className="headline">
              <div className={`brightcamera_anim ${this.state.isActive ? "active" : ""}`}></div>
              <div className="icon_desc">
                Super Bright Display
              </div>
              <div className="head">
                איך זה מרגיש
                </div>
              <div className="teaser">
                לאבד את הראייה
                </div>
              <Button context={"לכתבה המלאה"} className="purple" onClick={this.handlePaging} />
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default View;



// WEBPACK FOOTER //
// ./src/Components/Screens/4_View/View.jsx